import { render, staticRenderFns } from "./product-selector-page.vue?vue&type=template&id=2c970162&"
import script from "./product-selector-page.vue?vue&type=script&lang=ts&"
export * from "./product-selector-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wamp\\www\\Pentacom\\baumit.com\\vue-project\\calculator-common\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c970162')) {
      api.createRecord('2c970162', component.options)
    } else {
      api.reload('2c970162', component.options)
    }
    module.hot.accept("./product-selector-page.vue?vue&type=template&id=2c970162&", function () {
      api.rerender('2c970162', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/product-selector-page/product-selector-page.vue"
export default component.exports